/* global pendo */
import * as LDClient from "launchdarkly-js-client-sdk";
import appSettings from "../appSettings";
import FeatureFlagConstants from "../constants/featureFlagConstants";
import store from "../store";
import { environment } from "../env";

const clientSideID = appSettings.featuresClientSideId;
let ldClient = null;

function getUserFullName(user) {
  return user.firstName + " " + user.lastName;
}

function getUserCompanyKey(company, user) {
  return company.pakServiceId + "-" + user.pakServiceId;
}

let pendoUser = null;
let pendoCompany = null;
let pendoInitialized = false;

function flagChanged() {
  const messagingFlagValue = ldClient.variation(FeatureFlagConstants.MESSAGING, false);
  store.dispatch("featuresStore/updateMessagingFlag", messagingFlagValue);

  const aiDocTypeDetectionAndExtraction = ldClient.variation(
    FeatureFlagConstants.AI_DOCTYPE_DETECTION_AND_EXTRACTION,
    false
  );
  store.dispatch("featuresStore/updateAiDocTypeDetectionAndExtractionFlag", aiDocTypeDetectionAndExtraction);

  const pendoTracking = ldClient.variation(FeatureFlagConstants.PENDO_TRACKING, false);
  store.dispatch("featuresStore/updatePendoTrackingFlag", pendoTracking);

  if (pendoTracking && !pendoInitialized && typeof pendo !== "undefined" && pendoUser && pendoCompany) {
    pendoInitialized = true;
    pendo.initialize({
      visitor: {
        id: pendoUser.id,
        email: pendoUser.emailAddress,
        firstName: pendoUser.firstName,
        lastName: pendoUser.lastName,
      },
      account: {
        id: pendoCompany.id,
        companyName: pendoCompany.name,
        environment,
      },
    });
  }
}

export default {
  init: async (company, user) => {
    pendoUser = user;
    pendoCompany = company;
    pendoInitialized = false;

    const context = {
      kind: "user",
      key: getUserCompanyKey(company, user),
      companyName: company.name,
      name: getUserFullName(user),
      email: user.emailAddress,
    };

    ldClient = LDClient.initialize(clientSideID, context);

    ldClient.on("ready", flagChanged);
    ldClient.on("change", flagChanged);

    try {
      // Wait for initialization with a timeout of 5 seconds
      await ldClient.waitForInitialization(5000);
    } catch (error) {
      // "Initialization timed out" if it exceeds 5 seconds
      console.error(error.message);
    }
  },
};
